module.exports = __webpack_public_path__ + "static/media/house_targaryen.27a7dbaf.png";